<template>

	<div class="container main-content example-drag">
		<div class="row">
			<div class="col-12 col-md-7">

				<div class="row mb-4">
					<div class="col-12 text-center">
						<h4 class="dark-highlight mb-5">Verification Required</h4>
						<p>Please provide a photo of yourself holding up a piece of photo ID.  Ensure the photo is clear and your ID is easily readable.</p>
					</div>
				</div>
				
				<div class="row">
					<div class="col-12 text-center">
						<small class="error" v-if="hasError">{{ errorMsg }}</small>
					</div>
				</div>

				<div class="uploaded-files" v-if="files.length" :key="componentKey">

					<div v-for="file in files" :key="file.id" class="form-group">
						
						<div class="row pt-0 pb-4">
							
							<div class="col-12 col-md-10 word-wrap mb-3 mb-md-0">
								<img v-if="file.thumb" :src="file.thumb" width="40" height="auto" />
								<span v-else>No Image</span>
								<span class="ml-2">{{ file.name }}</span>
							</div>
							
							<div class="col-12 col-md-2 text-right-md text-left">
								<a href="#" title="Remove" class="btn btn-rounded btn-remove" v-if="!isUploading && !file.done" @click.prevent="remove(file)"><i class="fas fa-times"></i></a>

								<strong>	
									<span v-if="file.error" class="error">{{file.error}}</span>
									<span v-else-if="file.done" class="upload-success"><i class="fas fa-check"></i> success</span>
									<span v-else-if="isUploading && !file.done"><i class="fas fa-circle-notch fa-spin"></i> uploading</span>
								</strong>

							</div>
						</div>
						
					</div>
				</div>
				<div class="file-upload-box" v-else>
					<div class="text-center p-3">
						<h4 class="dark-highlight mb-4">Drop file anywhere to upload</h4>
						<img class="doc-upload-icon" src="./../assets/img/doc_upload_icon.png">
					</div>
				</div>

				<div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
					<h3>Drop file to upload</h3>
				</div>

				<div class="text-center row">
					
					<div class="col-12 col-md-6 pr-0 pl-0 mt-3">
						<file-upload
							class="btn btn-rounded btn-rounded-primary btn-upload mr-2"
							:custom-action="startAsyncUpload"
							:multiple="false"
							:drop="allowDrop"
							:drop-directory="false"
							:size="maxFileSize"
							:disabled="isUploading || !allowDrop"
							v-model="files"
							@input-filter="inputFilter"
							@input-file="inputFile"
							ref="upload"
							>
							<i class="fa fa-plus"></i>&nbsp;
							Select file
						</file-upload>
						
					</div>
					<div class="col-12 col-md-6 pr-0 pl-0 mt-3">
						<template v-if="uploadComplete || isUploading || this.files.length == 0">
							<a href="#" class="btn btn-rounded btn-upload disabled" v-on:click.prevent="noop">Start Upload</a>
						</template>
						<template v-else>
							<a href="#" class="btn btn-rounded btn-rounded-primary btn-upload btn-upload-start" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="validateForm">Start Upload</a>
						</template>
					
					</div>

					<div class="col-12 mt-4">
						<small class="col-6 text-center text-secondary">
							<a href="#" @click.prevent="back">Back</a>
						</small>
					</div>
					
				</div>
			</div>
			<div class="col-12 pt-5 pt-md-0 pl-0 offset-md-1 col-md-4 info-text">

				<h5 class="mb-4">Instructions</h5>

				<img class="w-100 mb-2" src="./../assets/img/selfie_example.jpg">
			
				<ol class="mb-4 pl-3 small">
					<li class="mb-2 pl-1"><strong>Must have photo ID in picture</strong> along with your face clearly visible</li>
					<li class="mb-2 pl-1"><strong>First</strong> and <strong>last name</strong> clearly visible on photo ID</li>
					<li class="mb-2 pl-1"><strong>Fully in frame</strong>, not cut off on any side</li>
				</ol>
				<hr />
				<p class="mb-2 small"><strong>List of Valid Government Issued Photo ID</strong></p>
				<ul class="pl-4 mb-4 small">
					<template v-if="$gstate.getActiveCountry() == 'AU'">
					<li class="mb-1">Australian Drivers License</li>
					<li class="mb-1">Australian ID Card</li>
					<li class="mb-1">Australian Passport</li>
					<li class="mb-1">Australian Residence Permit</li>
					</template>
					<template v-else>
					<li class="mb-1">Drivers License issued in Canada</li>
					<li class="mb-1">Canadian Passport</li>
					<li class="mb-1">Certificate of Canadian Citizenship (with photo)</li>
					<li class="mb-1">Permanent Resident Card</li>
					</template>
				</ul>

				<div class="row panel-warning p-3 mb-3" style="margin: 0 10px;">
					<div class="col-12 col-lg-2 text-center">
						<div class="exclamation" alt="Exclamation"></div>
					</div>
					<div class="col-12 col-lg-10 text-center text-lg-left text-warning">
						<small>Please follow the photo instructions carefully. Submitting only a scan of your ID will not be accepted!</small>
					</div>
				</div>

			</div>
		</div>
		
	</div>

</template>

<script>
/* eslint-disable */

import { eventBus } from './../main'
import { AsYouType, parseNumber, formatNumber, isValidNumber } from 'libphonenumber-js'

export default {
	data() {
		return {
			files: [],
			allowDrop: true,
			hasError: false,
			errorMsg: '',
			timeout: null,
			currentFile: null,
			componentKey: 0,
			isUploading: false,
			uploadComplete: false,
			maxFileSize: 4900000,
			mobileNumber: this.$gstate.getBuyerInfo().mobile
		};
	},
	created(){
		eventBus.$on('nextScreen', this.onEnterPress);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.onEnterPress);
	},
	methods: {
		onInput(){
			this.hasError = false;
		},
		back(){
			this.hasError = false;
			this.errorMsg = '';
			this.$router.push('image-input-choice');
		},
		onEnterPress(){
			this.validateForm();
		},
		validateForm(){

			if(this.uploadComplete){
				this.hasError = true;
				this.errorMsg = 'Documents already uploaded.'
				return;
			}

			if(this.files.length == 0){
				this.hasError = true;
				this.errorMsg = 'You must upload at least 1 file.'
				return;
			}

			this.isUploading = true;
			this.$refs.upload.active = true;
		},
		async startAsyncUpload(file, component) {
			
			var result = await this.uploadFile(file);

			if(result && result.error){
				// update the list with the error
				component.update(file, {error: result.msg});
			}

			return result;
		},
		uploadFile(file) {

			let reader = new FileReader()
			let theFile = file.file;
			theFile.id = file.id;
			
			// Convert the file to base64 text
			reader.readAsDataURL(theFile)
			reader.onload = () => {

				// Make a fileInfo Object
				let fileInfo = {
					name: theFile.name,
					type: theFile.type,
					size: Math.round(theFile.size / 1000)+' kB',
					base64: reader.result,
					file: theFile,
					id: theFile.id
				}
				
				this.currentFile = fileInfo;

				return new Promise(resolve => {
					
					var urlstr = this.$gstate.getApiBaseURL() + '/selfieimage';
					var id = this.currentFile.id;
					this.axios.post(urlstr, {
						refId: this.$gstate.getRefId(),
						mobileNumber : this.mobileNumber.countryCode + this.mobileNumber.areaCode + this.mobileNumber.phoneNumber,
						documentType : 'SELFIE',
						mimeType : this.currentFile.type,
						fileName : this.currentFile.name,
						extName : this.getFileExtention(this.currentFile.name),
						encodedFile : this.cleanBase64(this.currentFile.base64),
						imageSource : 'UPLOAD',
					}, this.$gstate.getAxiosHeaders())
						.then(response => {

							this.$gstate.log("done");
							this.$gstate.log(response);

							for(var i = 0; i < this.files.length; i++){
								if(this.files[i].id == id){
									this.files[i].done = true;
								}
							}

							if(this.isFinishedUploading()){
								this.isUploading = false;
								this.uploadComplete = true;
								this.$gstate.saveFlowStateAndProceed(response.data, this);
							}

							resolve('success');
						})
						.catch(error => {

							this.$gstate.log("error:");
							this.$gstate.log(error.response);
							this.hasError = true;
							this.isUploading = false;

							if(error.response){
								this.errorMsg = error.response.data.error.msg;
							} else {
								this.errorMsg = "Internal Server Error.  Please contact support for further assistance."
							}

						});
					
				});

			}
		},
		isFinishedUploading(){
			for(var i = 0; i < this.files.length; i++){
				if(!this.files[i].done){
					return false;
				}
			}

			return true;
		},
		getFileExtention(filename){
			return filename.split('.').pop();
		},
		cleanBase64(data){
			return data.substr(data.indexOf(',')+1);
		},
		inputFilter(newFile, oldFile, prevent) {
			if (newFile && !oldFile) {

				// Only allow image types of files
				if (!/\.(jpeg|jpe|jpg|gif|png|pdf)$/i.test(newFile.name)) {
					this.hasError = true;
					this.errorMsg = 'Only images and PDF\'s are allowed (jpg, gif, png, pdf).';
					return prevent();
				}

				// Only allow images 4.9 MB or less
				if(newFile.size > this.maxFileSize){
					this.hasError = true;
					this.errorMsg = 'File must be less than 4.5MB.  Your file is ' + this.byteToMb(newFile.size) + 'MB.';
					return prevent();
				}

				// Create a blob field
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if (URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}

				// Thumbnails
				newFile.thumb = ''
				if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
					newFile.thumb = newFile.blob
				}
			}

		},
		inputFile(newFile, oldFile) {
			if (newFile && !oldFile) {
				// add
				if(this.files.length >= 1){
					this.allowDrop = false;
				}
				
				// if we're adding new files after uploading some files, clear the old ones out
				if(this.uploadComplete){
					this.uploadComplete = false;
					
					// NEED to remove in reverse order.  Otherwise array for loop breaks because index shifts
					for(var i = this.files.length - 1; i >= 0; i--){
						if(this.files[i].id != newFile.id){
							this.remove(this.files[i]);
						}
					}
				}

			}
			if (newFile && oldFile) {
				// update
			}
			if (!newFile && oldFile) {
				// remove
			}

			this.hasError = false;

		},
		remove(file) {
			this.$refs.upload.remove(file)
			if(this.files.length == 0){
				this.allowDrop = true;
			}
		},
		byteToMb(value){
			return (value / 1000000).toFixed(2);
		}
	}
	
}

</script>
